import request from "@/utils/request";

export const getAreasCapRate = (lat, lng, distance) => {
  return request.get(
    "v1/cap/areas/map?lat=" +
      lat.toFixed(2) +
      "&lng=" +
      lng.toFixed(2) +
      "&distance=" +
      distance
  );
};
